import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-perte-exploitation',
  standalone: true,
  imports: [PageLayoutComponent],
  templateUrl: './assurance-perte-exploitation.component.html',
  styleUrls: ['./assurance-perte-exploitation.component.scss']
})
export class AssurancePerteExploitationComponent {
  title = 'Assurance Perte d\'Exploitation';
  subtitle = '';
  phoneNumber = '01 43 27 12 43';
  heroImage = 'assets/static_pages_images/perteEx.jpg';
  
  breadcrumbs = [
    { label: 'Professionnels', link: undefined },
    { label: 'Perte d\'Exploitation', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Protection Juridique Professionnelle',
    link: '/assurance-protection-juridique-pro'
  };

  nextPage = { 
    title: 'Assurance Homme-Clé',
    link: '/assurance-homme-cle'
  };

  constructor(private router: Router) {}

  navigateToContact(): void {
    this.router.navigate(['/contact']);
  }

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }
}
